import { psCollection } from "./powersync-collection.js";
import {
  storeSchema,
  staffPublicSchema,
  businessSchema,
  businessUserPublicSchema,
  deviceSchema,
  storePaymentMethodSchema,
  staffSessionSchema,
  roleSchema,
  staffShiftSchema,
  payrollRunSchema,
  bonusRuleSchema,
  bonusAwardSchema,
  businessIntegrationSchema,
  type Store,
  type StaffPublic,
  type Business,
  type BusinessUserPublic,
  type Device,
  type StorePaymentMethod,
  type StaffSession,
  type Role,
  type StaffShift,
  type PayrollRun,
  type BonusRule,
  type BonusAward,
  type BusinessIntegration,
} from "../schemas/core.js";

export const storesCollection = psCollection("stores", storeSchema);

export const businessesCollection = psCollection("businesses", businessSchema);

export const devicesCollection = psCollection("devices", deviceSchema);

/**
 * Staff, minus pin_hash — both the schema and the shape's `columns`
 * allowlist exclude it, so it never reaches the client. Inserts/updates
 * through this collection can't set a PIN either (`StaffPublic` has no
 * pin_hash field); use sync-api's POST /core/staff/:id/set-pin for that,
 * and POST /core/staff/:id/verify-pin to check one at sign-in.
 */
export const staffCollection = psCollection("staff", staffPublicSchema, {
  // base_salary only syncs to people with Payroll, in its own staff_pay table.
  select: "SELECT staff.*, staff_pay.base_salary AS pay FROM staff LEFT JOIN staff_pay ON staff_pay.id = staff.id",
  map: ({ pay, ...row }) => ({ ...row, base_salary: pay ?? 0 }),
});

/**
 * Owner Portal login accounts, minus password_hash — same exclusion
 * pattern as staffCollection above. Inserts through this collection can't
 * set a password either (`BusinessUserPublic` has no password_hash field);
 * use sync-api's POST /core/business-users/:id/set-password for that.
 */
export const businessUsersCollection = psCollection("business_users", businessUserPublicSchema);

export const storePaymentMethodsCollection = psCollection("store_payment_methods", storePaymentMethodSchema);

// Clock in/out — written by PIN-gated POS/Kitchen sessions, so stays
// unauthenticated (see services/sync-api/src/routes/core.ts).
export const staffSessionsCollection = psCollection("staff_sessions", staffSessionSchema);

export const rolesCollection = psCollection("roles", roleSchema);

export const staffShiftsCollection = psCollection("staff_shifts", staffShiftSchema);

export const payrollRunsCollection = psCollection("payroll_runs", payrollRunSchema);

export const bonusRulesCollection = psCollection("bonus_rules", bonusRuleSchema);

export const bonusAwardsCollection = psCollection("bonus_awards", bonusAwardSchema);

export const businessIntegrationsCollection = psCollection("business_integrations", businessIntegrationSchema);
